// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nhr[data-v-08322940] {\n\tborder: 0;\n\tborder-top: 1px solid #ddd;\n\theight: 1px;\n}\n.dashed[data-v-08322940] {\n\tborder-style: dashed;\n}\n.dotted[data-v-08322940] {\n\tborder-style: dotted;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
